import  { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileUpload, faFilePdf } from "@fortawesome/free-solid-svg-icons";

import "../../styles/auth.css";
import "../../styles/notes.css";
import "../../styles/search.css";
import "../../styles/main.css";
import "../../styles/index.css";

import { categories } from "../../helpers/mock-data";
import { BmsHeader } from "../../components/main-components/app.header";
import { AppFooter } from "../../components/main-components/footer";
import { Loader } from "../../components/utilities/loader";
import { useAuth } from "../../services/authentication/authentication.context";
import classNames from "classnames";
import { uploadPublication } from "../../services/documents/documents.context";
import { AppAlert } from "../../components/utilities/alert";
import { SkewBox } from "../../components/page/skew";


export const AddProjectPage = () => {

    const { isLoading, token } = useAuth ();

    const [bookData, setBookData] = useState({
        title: null,
        authors: null,
        publisher: null,
        publishedYear: null,
        category: null,
        document: null,
        documentType: "dissertation"
    });
    const [loading, setLoading] = useState(false);
    const [onAlert, setOnAlert] = useState();
    const [fileNm, setFileNm] = useState();

    const handleUpload = async (token , data) => {
        setLoading(true);
        const res = await uploadPublication(token, data);
            if (res?.error){
                setOnAlert({
                    caption: "Error",
                    message: res?.error,
                    acceptAction: () => {
                        setOnAlert();
                    }
                })
                return;
            }
            setOnAlert({
                caption: "Success",
                message: res?.message,
                acceptAction: () => {
                    setOnAlert();
                    window.location.reload();
                }
            })
            setLoading(false);
    }

    const fileButton = useRef();

    const { title, authors, document } = bookData;

    const inputRequired = () => {
        return isNull (title) || isNull(document) || isNull(authors);
    }

    const isNull = (v) => (v === "" || v === undefined || v === null);

    return (
        <div>
            <BmsHeader />
            <SkewBox title={"Upload new project"} />
            <div className="notes-page">
            {(loading || isLoading) && <Loader />}
           
                {onAlert && 
                    <AppAlert 
                        caption={onAlert.caption}
                        message={onAlert.message}
                        close={() => setOnAlert()}
                        accept={"Ok"}
                        acceptAction={onAlert.acceptAction}
                    />
                }
                <div className="main-page">
                    <div className="search-caption">Add project</div>
                        <div className="form-container">
                            <div className="input-container">
                                <span className="input-cap">
                                    Title
                                    <span className="req-asterix">*</span>
                                </span>
                                
                                <input 
                                    type="text" 
                                    placeholder="Title of lecture notes" 
                                    className="input"
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, title: e.target.value})
                                    )}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">
                                    Author(s)
                                    <span className="req-asterix">*</span>
                                </span>
                                <input 
                                    type="text" 
                                    className="input"
                                    placeholder="First names of authors" 
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, authors: e.target.value})
                                    )}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">Publisher</span>
                                <input 
                                    type="text" 
                                    className="input"
                                    placeholder="Publisher" 
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, publisher: e.target.value})
                                    )}
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">Published year</span>
                                <input 
                                    type="number" 
                                    className="input"
                                    placeholder="Year published" 
                                    onChange={(e) => setBookData((data) => 
                                        ({...data, publishedYear: e.target.value})
                                    )}
                                    required
                                />
                            </div>
                            <div className="input-container">
                                <span className="input-cap">
                                    Category
                                    <span className="req-asterix">*</span>
                                </span>
                                <select 
                                    type="text" 
                                    name="category" 
                                    id="category" 
                                    className={classNames("input", "category")} 
                                    required
                                    onChange={(e) => setBookData((data) => (
                                        {...data, category: e.target.value}
                                    ))}
                                >
                                    <option value={null} selected disabled>
                                        ---Choose subject area---
                                    </option>
                                    {categories.map((category, i) => (
                                        <option value={category} >{category}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="file-btn-container">
                                <input 
                                    type="file"
                                    className="file-button"
                                    ref={fileButton}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setBookData((data) => (
                                            {...data, document: e.target.files[0]}
                                        ))
                                        if (e.target.files[0].type !== "application/pdf") {
                                            setOnAlert({
                                                caption: "Error",
                                                message: `Invalid file type! Upload a pdf file`,
                                                acceptAction: () => {
                                                    setOnAlert();
                                                }
                                            })
                                            return;
                                        }
                                        setFileNm(e.target.files[0].name)
                                    }} 
                                />
                                <button
                                    onClick={() => fileButton.current.click()}
                                    className="file-click"
                                >
                                    <FontAwesomeIcon icon={faFileUpload} style={{marginRight: 8}} />
                                    Select notes file
                                </button>
                                {fileNm &&
                                    <span style={{marginLeft:16}}>
                                        <FontAwesomeIcon icon={faFilePdf} color="#f00" />
                                        {"  "}
                                        {fileNm}
                                    </span>
                                }
                            </div>
                            
                            <button 
                                className="form-button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (inputRequired()) {
                                        
                                        setOnAlert(
                                            {
                                                caption: "Error!",
                                                message: "Please provide all the required data",
                                                acceptAction: () => setOnAlert()
                                            }
                                        )
                                        return;
                                    }
                                    handleUpload(token, {...bookData, type: "dissertation"})
                                }}
                            >
                                Upload notes
                            </button>
                        </div>
                    </div>
                </div>
                <AppFooter />
            </div>
        
    )
}